export default function CTASection() {
  return (
    <section className="relative overflow-hidden">
      <div className="flex flex-col lg:flex-row">
        <div className="flex-1 relative min-h-[320px] md:min-h-[400px] bg-[#F5F0EA] flex items-end">
          <img
            src="https://readdy.ai/api/search-image?query=Interior%20of%20a%20premium%20sneaker%20boutique%20with%20floor-to-ceiling%20shelving%20warm%20recessed%20lighting%20polished%20concrete%20floor%20reflecting%20golden%20light%20architectural%20retail%20photography%20immersive%20shopping%20experience%20clean%20minimalist%20aesthetic%20editorial%20quality&width=1000&height=800&seq=cta-display-img-v2&orientation=landscape"
            alt="Organized pandabuy spreadsheet finds display"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
          <div className="relative z-10 p-8 md:p-12">
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-[1.05] drop-shadow-lg">
              Get<br />The Best<br />Finds
            </h2>
          </div>
        </div>

        <div className="flex-1 bg-background-50 flex items-center justify-center p-8 md:p-14">
          <div className="max-w-md text-center">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-[1.15]">
              Start Exploring<br />Pandabuy Finds
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              Access the complete pandabuy spreadsheet database with thousands of curated items across 14 categories. Find trending sneakers, streetwear, and accessories in seconds — not hours.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-7 inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              Buy It Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}